export default __webpack_public_path__ + "static/media/signal.ab680b76.png";